var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.currentComp,{tag:"component",attrs:{"url":"http://keystone.xtooltech.com/signin/login","domain":"Xtooltech","project":"x57NMjaKn93VYvQKXWDA","menus":_vm.menus,"autoCollapse":false},on:{"success":_vm.loginSuccess}})}
var staticRenderFns = []

export { render, staticRenderFns }